import { DateTime } from 'luxon'

import { AdvertResponseDTO } from '@core/api/dtos/response/campaign/advert'
import { Advert } from '@core/api/entities/campaign/advert'

export class AdvertMapper {
	static toEntity(data: AdvertResponseDTO): Advert {
		return new Advert({
			id: data.id,
			path: data.path,
			name: data.name,
			description: data.description ?? null,
			dateStart: data.date_start ? DateTime.fromISO(data.date_start) : null,
			dateEnd: data.date_end ? DateTime.fromISO(data.date_end) : null,
		})
	}

	static toEntities(data: AdvertResponseDTO[]): Advert[] {
		return data.map((item) => this.toEntity(item))
	}
}
